export default {
    loggingApiUrl: 'https://ep-app-loggingreports-api-dev-btf4hkdhczgngyfm.a01.azurefd.net/api',
    clientId: '68774a0d-37b9-4dd5-9cd1-5989455d6fd6',
    authority: 'https://login.microsoftonline.com/e5982410-a87c-4de2-966a-57de40702c63',
    LogLevel: 5,
    sampleRate: 0,
    sentryDsn: 'https://62cef205fc872a343f580ce581e74be0@o4509346579677184.ingest.de.sentry.io/4511300256464976'
};
